import React, { useEffect, useState } from 'react';
import { useIsBuyer } from '@/utils/hooks';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { CustomRedirect } from '@/components/navigation';
import NotFound from '@/components/error-pages/NotFound';
import { getChangeRequest } from '@/services/change-requests';

const ExternalLinksRoutingChangeRequest: React.FC<{ changeRequestId: number }> = ({ changeRequestId }) => {
    const isBuyer = useIsBuyer();
    const [projectId, setProjectId] = useState<number | null>(null);
    const [residentialUnitId, setResidentialUnitId] = useState<number | null>(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        async function load() {
            try {
                const changeRequest = await getChangeRequest(changeRequestId);
                setProjectId(changeRequest.projectId);
                setResidentialUnitId(changeRequest.residentialUnitId);
            } catch {
                setError(true);
            }
        }

        if (!isBuyer) {
            load();
        }
    }, [changeRequestId, isBuyer]);

    if (isBuyer) {
        return <CustomRedirect to={`/change-requests/${changeRequestId}`} />;
    }

    if (error) {
        return <NotFound />;
    }

    if (!projectId || !residentialUnitId) {
        return <LoadingIndicator />;
    }

    return (
        <CustomRedirect to={`/projects/${projectId}/residential-units/${residentialUnitId}/changes/${changeRequestId}`} />
    );
};

export default ExternalLinksRoutingChangeRequest;